import React from 'react';
import { func, bool } from 'prop-types';
import ManagedMembersSection from '@alltrails/communityapp/ManagedMembersSection';
import '@alltrails/communityapp/dist/ManagedMembersSection.css';
import ModalInterior from '@alltrails/shared/components/modals/ModalInterior';
import PrivacyTrigger from '@alltrails/shared/components/PrivacyTrigger';
import Checkbox24 from '@alltrails/shared/components/checkboxes/Checkbox24';
import PrivacyInformationBlock from '../../PrivacyInformationBlock';
import PrivacyPolicyPropType from '../../../../proptypes/PrivacyPolicyPropType';
import * as styles from './styles/styles.module.scss';
import {
  VISIBILITY_TO_OPTION,
  SUBJECT_TO_TITLE,
  COMPLETED_TRAILS,
  ACTIVITIES,
  CUSTOM_MAPS,
  LISTS,
  SOCIAL_NETWORK,
  FOLLOW_REQUESTS_REQUIRED
} from '../../../../utils/privacy_policy_helpers';
import { StringConstantsMixin } from '../../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';
import CustomProvider from 'components/CustomProvider';

const {
  strings: {
    SAVE,
    COMMUNITY: { COMMUNITY },
    PRIVACY_POLICY: {
      CONTENT,
      YOUR_NAME_YOUR_PROFILE_HOMETOWN,
      YOUR_CONTENT_DISPLAYED_WHEN_SOMEONE_ELSE,
      REVIEWS_AND_UPLOADED_SHARED,
      PRIVACY_SETTINGS,
      APPLY_TO_PAST_CONTENT
    }
  }
} = StringConstantsMixin;

const InitialPrivacyPolicyModal = ({
  isMounted,
  goBack,
  handleCloseModal,
  handleOnTransitionEnd,
  onPrivacyClick,
  onManagedMembersListClick,
  privacyPolicy,
  loading,
  handleSave,
  applyBulk,
  toggleApplyBulk
}) => {
  return (
    <ModalInterior
      title={PRIVACY_SETTINGS}
      isMounted={isMounted}
      closeModal={handleCloseModal}
      goBack={goBack}
      onTransitionEnd={handleOnTransitionEnd}
      baseCtas={{
        primaryCta: {
          onClick: () => handleSave(privacyPolicy, applyBulk),
          text: SAVE,
          testId: SAVE,
          loading,
          name: SAVE
        }
      }}
    >
      <PrivacyInformationBlock title={COMMUNITY} descriptions={[YOUR_NAME_YOUR_PROFILE_HOMETOWN]} />
      <PrivacyTrigger
        className={styles.privacyTrigger}
        onClick={() => onPrivacyClick(FOLLOW_REQUESTS_REQUIRED, privacyPolicy.socialNetwork.followRequestsRequired.toString())}
        label={SUBJECT_TO_TITLE[FOLLOW_REQUESTS_REQUIRED]}
        currentOption={VISIBILITY_TO_OPTION[privacyPolicy.socialNetwork.followRequestsRequired.toString()]}
      />
      <PrivacyTrigger
        className={styles.privacyTrigger}
        onClick={() => onPrivacyClick(SOCIAL_NETWORK, privacyPolicy.profile.socialNetwork.visibility)}
        label={SUBJECT_TO_TITLE[SOCIAL_NETWORK]}
        currentOption={VISIBILITY_TO_OPTION[privacyPolicy.profile.socialNetwork.visibility]}
      />
      <PrivacyInformationBlock title={CONTENT} descriptions={[YOUR_CONTENT_DISPLAYED_WHEN_SOMEONE_ELSE, REVIEWS_AND_UPLOADED_SHARED]} />
      <PrivacyTrigger
        className={styles.privacyTrigger}
        onClick={() => onPrivacyClick(COMPLETED_TRAILS, privacyPolicy.content.completedTrails.visibility)}
        label={SUBJECT_TO_TITLE[COMPLETED_TRAILS]}
        currentOption={VISIBILITY_TO_OPTION[privacyPolicy.content.completedTrails.visibility]}
      />
      <PrivacyTrigger
        className={styles.privacyTrigger}
        onClick={() => onPrivacyClick(ACTIVITIES, privacyPolicy.content.activities.visibility)}
        label={SUBJECT_TO_TITLE[ACTIVITIES]}
        currentOption={VISIBILITY_TO_OPTION[privacyPolicy.content.activities.visibility]}
      />
      <PrivacyTrigger
        className={styles.privacyTrigger}
        onClick={() => onPrivacyClick(CUSTOM_MAPS, privacyPolicy.content.customMaps.visibility)}
        label={SUBJECT_TO_TITLE[CUSTOM_MAPS]}
        currentOption={VISIBILITY_TO_OPTION[privacyPolicy.content.customMaps.visibility]}
      />
      <PrivacyTrigger
        className={styles.privacyTrigger}
        onClick={() => onPrivacyClick(LISTS, privacyPolicy.content.lists.visibility)}
        label={SUBJECT_TO_TITLE[LISTS]}
        currentOption={VISIBILITY_TO_OPTION[privacyPolicy.content.lists.visibility]}
      />
      <Checkbox24
        id="applyBulk"
        name="applyBulk"
        value="apply_bulk"
        checked={applyBulk}
        onChange={() => toggleApplyBulk(!applyBulk)}
        className={styles.checkbox}
        labelComponent={<div className={styles.checkboxLabel}>{APPLY_TO_PAST_CONTENT}</div>}
      />
      <CustomProvider>
        <ManagedMembersSection className={styles.managedMembers} onListClick={onManagedMembersListClick} />
      </CustomProvider>
    </ModalInterior>
  );
};

InitialPrivacyPolicyModal.propTypes = {
  isMounted: bool.isRequired,
  goBack: func,
  handleCloseModal: func.isRequired,
  handleOnTransitionEnd: func.isRequired,
  onPrivacyClick: func.isRequired,
  onManagedMembersListClick: func.isRequired,
  privacyPolicy: PrivacyPolicyPropType.isRequired,
  loading: bool,
  handleSave: func.isRequired,
  applyBulk: bool.isRequired,
  toggleApplyBulk: func.isRequired
};

InitialPrivacyPolicyModal.defaultProps = {
  goBack: null,
  loading: false
};

export default InitialPrivacyPolicyModal;
